import { render, staticRenderFns } from "./landing-sanLuis.vue?vue&type=template&id=1988bf6f&scoped=true&"
import script from "./landing-sanLuis.vue?vue&type=script&lang=js&"
export * from "./landing-sanLuis.vue?vue&type=script&lang=js&"
import style0 from "./landing-sanLuis.vue?vue&type=style&index=0&id=1988bf6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1988bf6f",
  null
  
)

export default component.exports